import React from 'react';
import { FadeInUp } from './FadeInUp';
import { ShieldCheck } from 'lucide-react';
export function Hero() {
  const scrollToForm = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    document.getElementById('lead-form')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-deep-blue text-white pt-24 pb-32 lg:pt-36 lg:pb-40 relative overflow-hidden" data-id="element-23">
      {/* Decorative Background Elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-24">
        <div className="absolute -top-40 -right-40 w-96 h-96 bg-vitality-green opacity-10 rounded-full blur-3xl" data-id="element-25"></div>
        <div className="absolute top-1/2 -left-20 w-72 h-72 bg-blue-400 opacity-10 rounded-full blur-3xl" data-id="element-26"></div>
        <div className="absolute bottom-0 right-1/4 w-64 h-64 bg-white opacity-5 rounded-full blur-2xl" data-id="element-27"></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10" data-id="element-28">
        <div className="grid lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-29">
          <div className="max-w-2xl" data-id="element-30">
            <FadeInUp data-id="element-31">
              <div className="inline-flex items-center gap-2 bg-white/10 border border-white/20 backdrop-blur-sm px-4 py-2 rounded-full mb-8" data-id="element-32">
                <ShieldCheck className="w-4 h-4 text-vitality-green" data-id="element-33" />
                <span className="text-sm font-medium tracking-wide text-blue-50" data-id="element-34">
                  Protección + Ahorro + Retiro
                </span>
              </div>
            </FadeInUp>

            <FadeInUp delay={0.1} data-id="element-35">
              <h1 className="text-4xl md:text-5xl lg:text-[3.5rem] font-bold tracking-tight leading-[1.1] mb-6" data-id="element-36">
                La mayoría de las familias latinas en USA trabajan duro… pero no
                tienen un plan real si algo pasa.
              </h1>
            </FadeInUp>

            <FadeInUp delay={0.2} data-id="element-37">
              <p className="text-lg md:text-xl text-blue-100/90 mb-10 leading-relaxed font-light" data-id="element-38">
                Déjame mostrarte en 15 minutos cómo proteger a tu familia y
                construir un retiro inteligente. Sin depender del banco. Sin
                depender del gobierno. Con un plan ajustado a tus objetivos.
              </p>
            </FadeInUp>

            <FadeInUp delay={0.3} data-id="element-39">
              <a href="#lead-form" onClick={scrollToForm} className="inline-flex items-center justify-center bg-vitality-green hover:bg-vitality-green-hover text-white font-semibold text-lg px-8 py-4 rounded-xl transition-all duration-300 shadow-[0_8px_30px_rgb(45,159,93,0.3)] hover:shadow-[0_8px_30px_rgb(45,159,93,0.5)] transform hover:-translate-y-1" data-id="element-40">
                Quiero mi asesoría
              </a>
            </FadeInUp>
          </div>

          <FadeInUp delay={0.4} className="relative" data-id="element-41">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl aspect-[4/3] lg:aspect-auto lg:h-[550px] border border-white/10" data-id="element-42">
              <img src="https://images.unsplash.com/photo-1511895426328-dc8714191300?w=800" alt="Familia hispana multigeneracional protegida" className="absolute inset-0 w-full h-full object-cover" data-id="element-43" />
              <div className="absolute inset-0 bg-gradient-to-t from-deep-blue/60 via-deep-blue/20 to-transparent" data-id="element-44"></div>
            </div>
            {/* Decorative dots behind image */}
            <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-[radial-gradient(#fff_2px,transparent_2px)] [background-size:16px_16px] opacity-20 -z-10 rounded-lg" data-id="element-45"></div>
          </FadeInUp>
        </div>
      </div>

      {/* Wave divider */}
      <div className="absolute bottom-0 left-0 w-full overflow-hidden leading-none" data-id="element-46">
        <svg className="relative block w-full h-[50px]" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none" data-id="element-47">
          <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V120H0V95.8C59.71,118.08,130.83,121.22,200.5,109.14C243.6,101.69,283.68,81.66,321.39,56.44Z" className="fill-light-gray" data-id="element-48"></path>
        </svg>
      </div>
    </section>;
}